const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';

// 🔹 Shared observer (better performance)
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry, index) => {
    const el = entry.target;

    if (entry.isIntersecting) {
      el.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      if (el.hasAttribute('data-cascade')) {
        el.style.setProperty('--animation-order', index);
      }
    } else {
      el.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    }
  });
}, {
  rootMargin: '0px 0px -50px 0px',
});

// 🔹 Init scroll animations
function initScrollAnimations(root = document) {
  const elements = root.querySelectorAll(`.${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`);
  elements.forEach(el => observer.observe(el));
}

// 🔹 Zoom animation (optimized)
function initZoomAnimations() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const elements = document.querySelectorAll(`.${SCROLL_ZOOM_IN_TRIGGER_CLASSNAME}`);
  if (!elements.length) return;

  const scaleAmount = 0.002;

  const update = () => {
    elements.forEach(el => {
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight;

      if (rect.top < vh && rect.bottom > 0) {
        const visible = Math.min(100, Math.max(0, ((vh - rect.top) / (vh + rect.height)) * 100));
        el.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * visible);
      }
    });

    requestAnimationFrame(update);
  };

  requestAnimationFrame(update);
}

// 🔹 Init
window.addEventListener('DOMContentLoaded', () => {
  initScrollAnimations();
  initZoomAnimations();
});

// 🔹 Shopify editor support
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => initScrollAnimations(e.target));
}